export const parentsListTitle = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "name", colWidth: "150px" },
  { titleName: "email", colWidth: "150px" },
  { titleName: "mobile", colWidth: "100px" },
  { titleName: "address", colWidth: "100px" },
  {
    titleName: "parental relationship",
    colWidth: "250px",
    key: "parentalRelationship",
  },
];

export const parentModalListTable = [
  {
    titleName: "id",
    colWidth: "20px",
  },
  { titleName: "name", colWidth: "120px" },
  { titleName: "email", colWidth: "140px" },
  {
    titleName: "parental relationship",
    colWidth: "150px",
    key: "parentalRelationship",
  },
];
